import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Conversation, Group, Profile, GroupMember } from 'tim-js-sdk';
import {
  OwnerLabelListItem,
  useTUILiveContext,
} from './context/TUILiveContext';

import './styles/index.scss';

import { useLiveAtiveElements } from './hooks/useLiveAtiveElements';
import { Icon, IconTypes, Avatar } from '@tencentcloud/chat-uikit-react';
import { formateNumber } from './untils';
import { useMediaQuery } from 'react-responsive';
import constant from '../../../constants';
import { getUrlParam } from '../../../utils/utils';
import { ANCHOR } from '../../../config/tencent';

const defaultUserAvatar =
  'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png';

export interface TUILiveFooterBaseProps {
  className?: string;
  conversation?: Conversation;
  group?: Group;
  ownerProfile?: GroupMember;
  myProfile?: Profile;
  ownerLabelList?: Array<OwnerLabelListItem>;
  contentList?: any;
  tim?: any;
}

interface TUILiveFooterProps extends TUILiveFooterBaseProps {
  TUILiveFooter?: React.ComponentType<TUILiveFooterBaseProps>;
  activePlugins?: Array<React.ReactElement>;
}

function UnMemoizedTUILiveFooter<T extends TUILiveFooterProps>(
  props: PropsWithChildren<T>
): React.ReactElement {
  const {
    className,
    conversation,
    group: porpsGroup,
    ownerLabelList: propsOwnerLabelList,
    ownerProfile: propsOwnerProfile,
    myProfile: propsMyProfile,
    TUILiveFooter,
    activePlugins: propsActivePlugins = [],
    contentList,
    tim,
  } = props;

  const {
    group: contextGroup,
    ownerProfile: contextOwnerProfile,
    myProfile: contextMyProfile,
    activePlugins: contextActivePlugins,
    ownerLabelList: contextOwnerLabelList,
    groupCounters,
  } = useTUILiveContext('TUILiveHeader');

  const roleCurrent = getUrlParam('role');
  const group = porpsGroup || contextGroup;
  const myProfile = propsMyProfile || contextMyProfile;
  const activePlugins = propsActivePlugins || contextActivePlugins;
  const [streamInfoData, setStreamInfoData] = useState<any>();

  if (TUILiveFooter) {
    <TUILiveFooter
      conversation={conversation}
      group={group}
      myProfile={myProfile}
    />;
  }

  const isMobile = useMediaQuery({ maxWidth: '768px' });
  const isSmallMobile = useMediaQuery({ maxWidth: '460px' });
  const ownerLabelList = propsOwnerLabelList || contextOwnerLabelList;
  const ownerProfile = propsOwnerProfile || contextOwnerProfile;
  const ownerProfileCustomField =
    ownerLabelList ||
    (ownerProfile?.memberCustomField || []).filter((item) => item?.value);

  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
  if(tim){
    fetch(
      constant.apiUrl +
      "/wp-json/stream/get-info?post_id=" +
      searchParams.get("roomId") +
      "&user_id=" +
      searchParams.get("userId")
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setStreamInfoData(result);

          searchParams.get('role') == constant.roleLiver && tim.setGroupCounters({
            groupID: searchParams.get("roomId"),
            counters: {'LiveFollow': result?.follow_number ?? 0}
          });
        },
        (error) => {
          console.log(error.message);
        }
      );
  }
  }, [tim]);

  const Tim = useLiveAtiveElements({
    icon: IconTypes.UNUNION,
    activeIcon: IconTypes.UNION,
    name: '',
    iconWidth: 22,
    iconHeight: 22,
    key: 'LiveHeart',
    value: streamInfoData?.like_follow_data?.is_liked,
    className: 'button-like-stream',
  });

  const Subscribe = useLiveAtiveElements({
    icon: IconTypes.UNVECTOR,
    activeIcon: IconTypes.VECTOR,
    name: searchParams.get('role') == constant.roleLiver ? formateNumber(groupCounters?.LiveFollow ?? 0) : 'Follow',
    key: 'LiveFollow',
    value: streamInfoData?.like_follow_data?.is_follow,
  });

  const LikeOrUnlike = useLiveAtiveElements({
    icon: IconTypes.LIKE,
    activeIcon: IconTypes.LIKED,
    name: formateNumber((groupCounters as any)?.LiveDemoLike, 1),
    value: false,
    key: 'LiveDemoLike',
    suffix: {
      icon: IconTypes.UNLIKE,
      activeIcon: IconTypes.UNLIKED,
      value: false,
    },
  });

  const plugins = [Subscribe, ...activePlugins].filter((item) => item);

  return (
    <footer className={`tui-live-footer ${className}`} 
    style={{
      height: roleCurrent === ANCHOR ? '104px' : '120px',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <Avatar size={56} image={ownerProfile?.avatar || defaultUserAvatar} />
        <div className='tui-live-footer-main'>
          <div className='owner-name'>
            <h1 className='ellipsis-1'>{ownerProfile?.nick || ownerProfile?.userID}</h1>
          </div>
          <ul className='tui-live-list tag-list'>
            {ownerProfileCustomField?.map((item) => (
              <li className='tui-live-item tag-item' key={item.value}>
                {item?.value}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <ul className='tui-live-list opate-list'>{plugins}</ul>

        {isMobile && (
          <ul className='tui-live-list'>
            {contentList?.map((item: any) => (
              <li className='tui-live-item' key={item.icon}>
                <img className='icon icon-eye' src={item?.icon} alt='eye' />
                <span className='list-item-text'>
                  {formateNumber(item.value || 0, 1)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </footer>
  );
}

export const TUILiveFooter = React.memo(
  UnMemoizedTUILiveFooter
) as typeof UnMemoizedTUILiveFooter;
